import React from 'react';

import IconCopy from '../../assets/images/common/icon-copy.svg';
import IconDelete from '../../assets/images/common/icon-delete.svg';

import { DeviceInfoRow, DeviceInfoInputRow, EstimateInquiry } from '../../types/common/EstimateInquiryType';
import { MasterPrefectureApiResponse } from '../../types/api/MasterPrefectureApiType';

import { EditDeviceListEditRow } from './EditDeviceListEditRow';
import { EditDeviceListLogic } from './editDeviceListLogic';
import { AppDispatch } from '../../store/store';


type EditDeviceListRowProps = {
    rowNumber: number; // 行番号
    estimateInquiry: EstimateInquiry; // 見積り問合せ
    deviceInfoRow: DeviceInfoRow; // 本部品で表示する行
    dispatch: AppDispatch; // dispatch
    masterPrefecture: MasterPrefectureApiResponse;
};

export const EditDeviceListRow: React.FC<EditDeviceListRowProps> = ({
    rowNumber,
    estimateInquiry,
    deviceInfoRow,
    dispatch,
    masterPrefecture,
}) => {
    const SPACE = '　';

    // 各項目のstate更新
    const setStateRowValue = (changedRowValue: DeviceInfoInputRow) => {
        void EditDeviceListLogic.setStateDeviceRowValue(
            dispatch,
            estimateInquiry,
            changedRowValue
        );
    };

    // 編集行追加
    const addEditRow = () => {
        void EditDeviceListLogic.addEditRow(dispatch, rowNumber, estimateInquiry);
    };

    // 編集行削除
    const deleteEditRow = (changeRowNum: number) => {
        void EditDeviceListLogic.deleteEditRow(dispatch, rowNumber, changeRowNum, estimateInquiry);
    };

    // 機器行の削除
    const deleteDeviceRow = () => {
        void EditDeviceListLogic.deleteDeviceRow(dispatch, rowNumber);
    };

    return (
        <div className='device-list-area-row'>
            <div className='edit-device-list-row'>
                <dl>
                    <dt>
                        <h3>
                            <span className='model-name'>
                                {deviceInfoRow.makerName ? `${deviceInfoRow.makerName}${SPACE}` : ''}
                                {deviceInfoRow.modelName ? deviceInfoRow.modelName : deviceInfoRow.searchWord}
                            </span>
                        </h3>
                    </dt>
                </dl>

                {deviceInfoRow.inputList.map((inputRow, index) => {
                    return (
                        <React.Fragment key={`Edit-row-${rowNumber}-${index}`}>
                            <EditDeviceListEditRow
                                index={index}
                                inputRow={inputRow}
                                inputListLength={deviceInfoRow.inputList.length}
                                setStateRowValue={setStateRowValue}
                                deleteEditRow={deleteEditRow}
                                masterPrefecture={masterPrefecture}
                            />
                        </React.Fragment>
                    );
                })}
                <div className='edit-device-list-buttons'>
                    <button className='edit-device-list-add-button' onClick={() => addEditRow()}>
                        設置情報を追加する
                        <span className='icon is-small copy-icon'>
                            <img src={IconCopy} alt='' />
                        </span>
                    </button>
                    <button className='edit-device-delete-button' onClick={() => deleteDeviceRow()}>
                        機器情報全般を削除する
                        <span className='icon is-small delete-icon'>
                            <img src={IconDelete} alt='' />
                        </span>
                    </button>
                </div>
            </div>
        </div>
    );
};
